export {
  Tab,
  TabsBorder,
  TabsColor,
  TabsDirection,
  TabsSize,
  QueryParamsHandling,
} from './tab-item.component';
